import Lottie from "lottie-react";
import Spinner from "@assets/spinners/spinner.json";

const ButtonLoader = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="max-h-[20px] max-w-[20px]">
        <Lottie
          loop={true}
          autoplay={true}
          animationData={Spinner}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice",
          }}
        />
      </div>
    </div>
  );
};

export default ButtonLoader;
